<template>
    <section class="result" :style="{minHeight: innerHeight - 68 + 'px'}">
        <div class="title">Blahoželáme!</div>
        <div class="subtitle animated infinite pulse">Vaše telefónne číslo bolo úspešne zaregistrované!</div>
        <div
                class="text"
        >Zavolajte z Vášho mobilného čísla a získajte prístup k osobnej audio správe:
        </div>
        <div class="weight">"Získajte týždenne 1000 €!"</div>
        <div class="timer">Audio správa bude vymazaná za:
            <Timer/>
        </div>
        <div class="info">
            <div class="info-title">
                Počet účastníkov je prísne obmedzený.
            </div>
            <div class="info-text">Zavolajte hneď teraz, nepremeškajte svoju šancu!</div>
        </div>
        <div class="result-button">
            <a class="button animated infinite pulse callBtn" :href="'tel:'+ defaultPhoneNumber" @click="sendNumber">
        <span class="button__text">
          Zavolajte a vypočujte si správu
        </span>
            </a>
        </div>
        <div class="footer" :style="footerPos()">
            <p>
                Cena hovoru je <b>2 EUR/minúta</b> plus poplatky Vášho operátora za prepojenie, hovory sa nahrávajú,<br>
                iba pre zábavu 18+.<br>
                Odpovedaním na otázky súhlasíte so zberom údajov. <br>
                © {{ new Date().getFullYear() }}. <span class="noaff">ABCMobile OÜ</span> <br> <br>
                Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia. <br>
                Zákaznícky servis <a href="https://abchelp.me/sk">https://abchelp.me/sk</a> <br>
                Pozrite si naše <a href="./terms.php">Obchodné podmienky</a> a <a href="./privacy.php">Zásady ochrany
                osobných údajov</a>
                <br>
                <span class="noaff">Affiliate: <a href="http://mobstra.com/">mobstra.com</a></span>
            </p>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    @import url("../assets/animation.css");

    .result {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        max-width: 300px;
        margin: 0 auto;
        max-height: 850px;
        min-height: 492px;
        padding-bottom: 24px;

        &-button {
            margin-left: 20px;
        }
    }

    .title {
        font-weight: bold;
        font-size: 25px;
        line-height: 29px;
        text-transform: uppercase;
        color: #2f9e31;
    }

    .subtitle {
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: #2f9e31;
    }

    .text {
        font-size: 16px;
        line-height: 19px;
        color: #000000;
    }

    .weight {
        font-weight: bold;
        font-size: 23px;
        line-height: 28px;
        text-transform: uppercase;
        color: #000000;
    }

    .timer {
        font-size: 12px;
        line-height: 14px;
        color: #b81b1e;
    }

    .info {
        background: #fffdf2;
        border: 1px solid #f8d259;
        border-radius: 10px;
        padding: 10px 15px;

        &-title {
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            color: #000000;
            margin-bottom: 9px;
        }

        &-text {
            font-size: 16px;
            line-height: 19px;
            color: #000000;
        }
    }

    .button {
        text-decoration: none;
        background: linear-gradient(
                        180.83deg,
                        #4cb050 7.87%,
                        #1a821c 60.97%,
                        #01421f 97.69%
        );
        border-radius: 10px;
        display: flex;
        justify-content: center;
        text-align: left;
        width: 245px;
        min-height: 71px;
        margin: 0 auto;
        align-items: center;
        position: relative;
        z-index: 1;

        &::before {
            content: url("../assets/img/call.svg");
            animation: infinite tada 2s;
            position: absolute;
            left: -15px;
            background: linear-gradient(
                            345.42deg,
                            #2f9e31 -28.42%,
                            #1a821c 92.44%,
                            #01421f 165%
            );
            border-radius: 50%;
            padding: 12.5px;
            z-index: 20;
        }

        &:after {
            content: "";
            position: absolute;
            width: 80px;
            height: 80px;
            left: -25px;
            background: linear-gradient(
                            180.83deg,
                            #4cb050 7.87%,
                            #1a821c 60.97%,
                            #01421f 97.69%
            );
            z-index: 11;
            border-radius: 50%;
        }

        &__text {
            color: #fff;
            font-weight: bold;
            padding-left: 57px;
            font-size: 17px;
            letter-spacing: 0.05em;
        }
    }

    .footer {
        position: absolute;
        color: #787878;
        font-size: 11px;
        left: 50%;
        width: 95%;
        margin: 0 auto;
        max-width: 400px;
        flex-shrink: 1;

        transform: translate(-50%, 0);

    }
</style>

<script>
    import Timer from '../components/Timer'
    import sendPhone from '../mixins/sendPhone'

    export default {
        data: () => ({
            innerHeight: window.innerHeight,
            defaultPhoneNumber: $default_tel
        }),
        components: {Timer},
        props: ['userPhone'],
        mixins: [sendPhone],
        methods: {
            footerPos() {
                let res
                if (this.innerHeight > 480) {
                    res = `top: ${this.innerHeight - 24}px`
                } else {
                    res = 'position: static;transform:none;'
                }

                return res
            }
        },
        mounted() {
            window.onresize = () => (this.innerHeight = window.innerHeight);
        }
    };
</script>